import script from "./ChangePasswordModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChangePasswordModal.vue?vue&type=script&setup=true&lang=ts"

import "./ChangePasswordModal.vue?vue&type=style&index=0&id=37773ac4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37773ac4"]])

export default __exports__